// extracted by mini-css-extract-plugin
export var boldOverlay = "PageDataBodyWeRideHero-module--boldOverlay--Sksjw";
export var container = "PageDataBodyWeRideHero-module--container--XAGSP";
export var copyText = "PageDataBodyWeRideHero-module--copyText---TOa6";
export var header = "PageDataBodyWeRideHero-module--header--OoDR3";
export var headerContainer = "PageDataBodyWeRideHero-module--headerContainer--txagq";
export var textContainer = "PageDataBodyWeRideHero-module--textContainer--6npcr";